@if (data.mode=='confirm') {
<div mat-dialog-title>
  <div class="top-button" (click)="onNoClick()"></div>
  <div class="dialog-title">Хотите отменить подписку?</div>
</div>
<mat-dialog-content>
  <div class="dialog-text">Отменив подписку, вы больше не сможете использовать все преимущества DexBee Plus</div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()" class="button-yes">Оставить</button>
  <button matButton (click)="onYesClick()" class="button-no">Отменить</button>
</mat-dialog-actions>
}
@if (data.mode=='completed') {
<div mat-dialog-title class="top-button" (click)="onNoClick()"></div>
<div class="ok-icon"></div>
<div class="dialog-ok-text">Подписка отменена</div>
<div class="button-ok-block">
  <button matButton (click)="onOkClick()" class="button-ok">Ok</button>
</div>
}
